module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['col-md-3 sidebar-col', _vm.categoriesVisible ? 'visible' : '']
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Menu")]), _vm._v(" "), (_vm.categories) ? _c('ul', {
    staticClass: "menu-categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('li', {
      class: _vm.selectedListCategorySlug === category.slug ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.changeSelectedCategory(category.slug, category.title)
        }
      }
    }, [_vm._v("\n                " + _vm._s(category.title) + "\n              ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top-bg-separator"
  })])]), _vm._v(" "), _c('div', {
    class: ['col-md-9 menu-col', _vm.categoriesVisible ? 'not-visible' : '']
  }, [_c('div', {
    staticClass: "toggle-categories btn btn-danger btn-xs",
    on: {
      "click": function($event) {
        _vm.categoriesVisible = !_vm.categoriesVisible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v(" Categories")]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "selected-menu"
    }
  }, [(_vm.selectedCategoryTitle) ? _c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.selectedCategoryTitle))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-items"
  }, [(_vm.products) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.products), function(product) {
    return _c('div', {
      class: [_vm.selectedCategorySlug === product.category.slug ? 'animated fadeIn' : 'display-none', _vm.productsFadeOut ? 'animated fadeOut' : '', 'col-md-12']
    }, [_c('div', {
      staticClass: "product-item"
    }, [_c('div', {
      staticClass: "image"
    }, [(product.gallery.length) ? _c('img', {
      attrs: {
        "src": _vm.base_url + '/' + product.gallery[0].image_path,
        "alt": product.title
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/img/food.png"),
        "alt": product.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('h3', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(product.title))]), _vm._v(" "), _c('p', {
      staticClass: "item-description"
    }, [_vm._v("\n                        " + _vm._s(product.description) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [(product.discount > 0) ? _c('span', {
      staticClass: "total-price has-discount"
    }, [_c('span', {
      staticClass: "old-price"
    }, [_vm._v("£ " + _vm._s(product.price.toFixed(2)))]), _vm._v(" "), _c('span', {
      staticClass: "discount"
    }, [_vm._v("£ " + _vm._s(product.discount.toFixed(2)))])]) : _c('span', {
      staticClass: "total-price"
    }, [_vm._v("\n                      £ " + _vm._s(product.price.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('span', {
      staticClass: "q-add",
      on: {
        "click": function($event) {
          product.quantity++
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "q-total"
    }, [_vm._v(_vm._s(product.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "q-sub",
      on: {
        "click": function($event) {
          product.quantity > 1 ? product.quantity-- : product.quantity
        }
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
      staticClass: "add-to-cart"
    }, [_c('b-button', {
      staticClass: "btn-danger add-to-cart-btn btn-sm",
      attrs: {
        "disabled": !product.availability
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(product.title, product.code, product.gallery.length ? _vm.base_url + '/' + product.gallery[0].image_path : '', product.id, product.price, product.discount, product.quantity)
        }
      }
    }, [_c('span', {
      staticClass: "not-mobile"
    }, [_vm._v(_vm._s(product.availability ? 'Add to cart' : 'Out of stock'))]), _vm._v(" "), _c('span', {
      staticClass: "mobile"
    }, [_vm._v("+")])])], 1)])])
  }), _vm._v(" "), (_vm.products.length === 0 || _vm.categories.length === 0) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                  There are no products to display.\n                ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.products) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-center pt-2 pb-2"
  }, [_c('div', {
    staticClass: "loader-1"
  }, [_c('span')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57ac1373!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/menu/menu.vue
// module id = 553
// module chunks = 1